import React from "react";
import styled from "styled-components";
import TermlyEmbed from "../components/TermlyEmbed";

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 64px;
  padding: 0 24px 64px;
  max-width: 1080px;
  min-height: calc(100vh - 444px);

  color: var(--body-text);

  a {
    color: var(--brand-pink);
  }
`;

function PrivacyPolicy() {
  return (
    <Container>
      <TermlyEmbed dataId="1dbe142a-ea46-4e1c-af38-6aae33801df1" />
    </Container>
  );
}

export default PrivacyPolicy;
